// extracted by mini-css-extract-plugin
module.exports = {"webhookList":"style_webhookList__JEw8g","flex":"style_flex__2Bts-","iconMargin":"style_iconMargin__1fDWa"};